<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>部门与岗位</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align: left">
        <el-col :span="24">
          <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item>
              <el-input
                filterable
                v-model="name"
                clearable
                size="small"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="tableData"
            ref="multipleTable"
            style="width: 100%"
            @row-click="openDetails"
          >
            <el-table-column
              align="center"
              label="+"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="">
                <span>{{ "+" }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="部门名称"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Frame.ClassName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="等级编码"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Frame.Level }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="等级名称"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Frame.LevelName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click.stop
                  @click="addFrameDuty(scope.row)"
                  >添加岗位</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="部门下岗位" :visible.sync="dialogFormVisible2">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="tableDataDetails"
            ref="multipleTable"
            style="width: 100%"
          >
            <el-table-column
              label="编号"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Id }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="岗位名称"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.ClassName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="排序"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.Sort }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  @click="batchDeleteDutyInfo(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="添加岗位" :visible.sync="dialogFormVisible">
      <el-form
        :model="FormBody"
        :inline="true"
        class="demo-ruleForm"
        size="small"
      >
        <el-row>
          <el-col :span="9">
            <el-form-item size="small" label="部门名称" prop="SalaryMoney">
              <el-input readonly  v-model="ClassName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-select
                filterable
                v-model="FormBody.dutyId"
                clearable
                placeholder="请选择岗位名称"
               
                size="small"
                prop="TypeId"
              >
                <el-option
                  v-for="(item, index) in DutySystemList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import {
  DeleteSysitem,
  GetSingleSysItem,
  GetSingleSysItemSort,
  AddSysItem,
  GetSysItemListByParentID,
  AddSalaryInfo,
  GetSingleSalaryInfo,
  DeleteSalaryInfo,
  GetFixedPerformanceList,
  GetSingleFixedPerformance,
  AddFixedPerformance,
  DeleteFixedPerformance,
  GetFrameDutyList,
  DeleteDuty,
  SaveFrameDuty,
} from "../../until/ZeusApiSDK/Logic/SalaryStanded";
export default {
  data() {
    return {
      frameID: "",
      ClassName: "",
      name: "", //部门名字搜索条件
      DutySystemList: [], //岗位类别集合
      currentUser: {}, //当前用户
      tableData: [],
      tableDataDetails: [],
      TypeId: "",
      loading: true,
      visible: false,
      // 弹窗dialog
      dialogFormVisible: false,
      dialogFormVisible2: false,
      FormBody: {
        frameId: "", //部门id0
        dutyId: "", //岗位类别ID
        userCode: "", //工号
      },
    };
  },
  created() {
    //获取当前用户信息
    this.getCurrentUser();
    this.GetFrameDutyList();
    this.getJobSysitemList();
  },
  methods: {
    
       batchDeleteDutyInfo: async function (row) {
        var data = {
        frameId: this.frameID,
        dutyId: row.Id,
        userCode: this.currentUser.UserCode,
      };
      console.log(data);
      //删除操作
      DeleteDuty(data).then((res) => {
        if (res.Code == "200") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.GetSalaryInfoList();
        } else if (res.Code == "500") {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "error",
          });
          this.GetSalaryInfoList();
        } else {
          this.$message({
            showClose: true,
            message: "未知",
            type: "error",
          });
          this.GetSalaryInfoList();
        }
      });
    },

    //现有薪级
    selectGetDuty: async function (vId) {
      let obj = {};
      obj = await this.DutySystemList.find((item) => {
        if (item.Id == vId) {
          this.FormBody.dutyId = item.ClassName;
        }
      });
    },

    addFrameDuty(row) {
      this.dialogFormVisible = true;
      this.ClassName = row.Frame.ClassName;
      this.FormBody.frameId = row.Frame.Id;
    },
    openDetails(row) {
      this.frameID = row.Frame.Id;
      this.dialogFormVisible2 = true;
      this.tableDataDetails = row.SysItemList;
    },
    //获取岗位集合下拉列表
    getJobSysitemList: async function () {
      await GetSysItemListByParentID("8").then((res) => {
        this.DutySystemList = res.Data.DataList;
        console.log(this.DutySystemList);
      });
    },
    //获取当前用户
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取薪资结构列表
    GetFrameDutyList: async function () {
      await GetFrameDutyList(this.name).then((res) => {
        this.loading = false;
        console.log(res.Data.DataList);
        this.tableData = res.Data.DataList;
      });
    },
    
    quotaSearch() {
      // 执行搜索
      this.GetFrameDutyList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
    },
    handleChangeDialog() {
      // 编辑或新增保存
     
       var data = {
        frameId: this.FormBody.frameId,
        dutyId: this.FormBody.dutyId,
        userCode: this.currentUser.UserCode,
      };
     console.log(data);
      SaveFrameDuty(data).then((res) => {
        if (res.Result == "1") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "error",
          });
        }
        console.log(res.Msg);
        // 关闭弹窗
        this.cancelDialog();
      });
    },

    cancelDialog() {
      this.dialogFormVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
